module.exports = __webpack_public_path__ + "static/img/silk.54ed495.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xiangyun/silk.png
// module id = Q6Au
// module chunks = 1